export default __webpack_public_path__ + "static/media/plastcor.ab43abe6.png";